import service from './Setting'


export const BarCode = (obj) => service.post('/ECPay/InvoiceVerify/BarCode',obj);
export const LoveCode = (obj) => service.post('/ECPay/InvoiceVerify/LoveCode',obj);
export const UnifiedBusinessNo = (obj) => service.post('/ECPay/InvoiceVerify/UnifiedBusinessNo',obj);

